/* istanbul ignore file */
import { BaseAccessPlanData } from './BaseAccessPlanData';
const UpdateAccessPlanDataParser = 
/* #__PURE__ */ BaseAccessPlanData;
export class UpdateAccessPlanData extends BaseAccessPlanData {
    static decode(input) {
        return UpdateAccessPlanDataParser.decode(input).map(res => new UpdateAccessPlanData(res));
    }
    static unsafeDecode(input) {
        return UpdateAccessPlanData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return UpdateAccessPlanDataParser.encode(data);
    }
    static schema() {
        return UpdateAccessPlanDataParser.schema();
    }
}
